exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2zFCxYZ_Gg7xypfQ_0zru1{\n    fill-opacity: 0.85 ;\n}\n._2zFCxYZ_Gg7xypfQ_0zru1:hover{\n    fill-opacity: 1 ;\n    -webkit-box-shadow: 0 0 11px rgba(33, 33, 33, 0.493);\n            box-shadow: 0 0 11px rgba(33, 33, 33, 0.493); \n    width: 1000px;\n    cursor: pointer;\n}", ""]);

// exports
exports.locals = {
	"beat": "_2zFCxYZ_Gg7xypfQ_0zru1"
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/pages/Annotation/components/Beat/beat.css
// module id = 10454
// module chunks = 23